import { Col, Row } from 'antd';
import React from 'react';
import Title from 'antd/es/typography/Title';
import jwt_decode from 'jwt-decode';
import { useUserState } from '../../Hooks/useUserState';
import { RequestBookingInfoProvider } from './hooks/useCurrentRequestBooking';
import BookingsTabs from './Components/BookingsTabs';

const BookingView = () => {
    const { setAuth, ...state } = useUserState();

    const decoded: { _id: string; sectionRoles: [string] } = state?.accessToken
        ? jwt_decode(state?.accessToken)
        : undefined;

    return (
        <>
            <Row style={{ paddingBottom: 10, paddingTop: 20 }}>
                <Col span={12}>
                    <Title level={3}>Bookings</Title>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <RequestBookingInfoProvider>{<BookingsTabs />}</RequestBookingInfoProvider>
                </Col>
            </Row>
        </>
    );
};

export default BookingView;
